import React, { useEffect, useState } from 'react';
import BasicSalesDetails from "./BasicSalesDetails"
import SalesMappedUser from "./SalesMappedUser"
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getRoleListing } from "../../../../../store/slices/RoleUser"
import { toast } from "react-toastify";
import { getAgencySalesUsers } from '@src/store/slices/agency';
import { getMasterConfig } from '@src/store/slices/common';
import { USER_EMAIL_REGEX, USER_PASSWORD_REGEX, USER_MOBILE_REGEX } from "@src/config/constant";
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '@src/common/FullPageLoader';

const MapDealerManagement = (props: any) => {

  const dispatch: any = useDispatch();
  const [formData, setFormData] = useState<any>({
    name: "",
    email: "",
    mobile: "",
    password: "",
    channel_type: "",
    role_id: "",
    reporting_role: "",
    reporting_name: "",
    map_sales_agent_officer: [],
    role_slug: "",
    status: 1
  });

  const [errors, setErrors] = useState<any>({});
  let [roleList, setRoleList] = useState<any>([]);
  let [salesUserList, setSalesUserList] = useState<any>([]);
  const [agencyAgentData, setAgencyAgentData] = useState<any[]>([]);
  const [agencyList, setAgencyList] = useState();
  let [loading, setLoading] = useState<boolean>(false)

  const email_regex = USER_EMAIL_REGEX;
  const password_regex = USER_PASSWORD_REGEX;
  const mobile_regex = USER_MOBILE_REGEX;
  const commonState = useSelector((state: any) => state.common);
  
  const queryParams = useParams();
  const navigate = useNavigate();
  const agency_id = queryParams.id

  const handleChange = (field: string, value: string) => {
     errors[field] = '';
    setFormData((prev: any) => ({ ...prev, [field]: value }));
    setErrors({ ...errors })
  };


  // Validation Function
  const isFormValid = (formData: any) => {
    let isValid = true;
    let newErrors: any = {};

    if (!formData.name || formData.name.trim() === "") {
      newErrors["name"] = "Name is required";
      isValid = false;
    } else if (formData.name.length < 3 || formData.name.length > 30) {
      newErrors["name"] = "Name should be between 3 to 30 characters";
      isValid = false;
    }

    //const mobile_regex = /^[0-9]{10,12}$/; // example
    if (!formData.mobile || formData.mobile === "") {
      newErrors["mobile"] = "Mobile number is required";
      isValid = false;
    } else if (!mobile_regex.test(String(formData.mobile))) {
      newErrors["mobile"] = "Invalid Mobile number";
      isValid = false;
    }

    if (!formData.email || formData.email === '') {
      newErrors['email'] = 'Email is required';
      isValid = false;
    } else if (!email_regex.test(formData.email)) {
      newErrors['email'] = 'Invalid Email';
      isValid = false;
    }
    else {
      const EMAIL_DOMAINS = ["zeninsure", "carmudi"];
      const emailDomain = formData.email.split("@")[1]?.toLowerCase() || "";
      if (!EMAIL_DOMAINS.some((d: any) => emailDomain.includes(d))) {
        newErrors['email'] = 'Only ZenInsure or Carmudi emails are allowed';
        isValid = false;
      }
    }

    if (!agency_id) {
      if (!formData.password || formData.password === '') {
        newErrors['password'] = 'Password is required';
        isValid = false;
      } else if (!password_regex.test(formData.password)) {
        newErrors['password'] = 'Password should be atleast 8 character with 1 special char,1 Uppercase,1 lowercase and 1 digit';
        isValid = false;
      }
    }

    if (!formData.channel_type) {
      newErrors["channel_type"] = "Channel type is required";
      isValid = false;
    }

    if (!formData.role_id) {
      newErrors["role_id"] = "User Role is required";
      isValid = false;
    }

    if (!formData.reporting_role) {
      newErrors["reporting_role"] = "Reporting Role is required";
      isValid = false;
    }

    if (formData.role_slug !== 'admin') {
      if (!formData.reporting_name) {
        newErrors["reporting_name"] = "Reporting Username is required";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };


  const handleSubmit = async () => {
    try {
      if (isFormValid(formData)) {
        setLoading(true);
        let payload: any;

        if (agency_id) {
          // edit case
          payload = { id: agency_id, ...formData };

          // agar password empty hai to hata do
          if (!formData.password || formData.password.trim() === "") {
            delete payload.password;
          }
        } else {
          // add case
          payload = { ...formData };
          // check mapped Agency user is required
          if(formData.role_slug === "sales_officer" && (formData?.map_sales_agent_officer?.length === 0  || !formData?.map_sales_agent_officer)){
            setLoading(false);
            return toast.error("Please select Mapped Agency");
          }
        }

        //if reporting_name empty remove
        if (formData.reporting_name === undefined ||formData.reporting_name === null ||(typeof formData.reporting_name === 'string' && formData.reporting_name.trim() === '')) {
          delete payload.reporting_name;
        }

         delete payload.role_slug;

        dispatch(getRoleListing.saveSalesAgencyUserData(payload))
          .then((res: any) => {
            if (res && res.status === 200) {
              toast.success(agency_id ? "User updated successfully!" : "User added successfully!");

              if (!agency_id) {
                // reset
                setFormData({
                  name: "",
                  email: "",
                  mobile: "",
                  password: "",
                  channel_type: "",
                  role_id: "",
                  reporting_role: "",
                  reporting_name: "",
                  map_sales_agent_officer: [],
                  role_slug: "",
                  status: ""
                });
                setErrors({});
              }
              navigate('/agency-sales-user-list');
              setLoading(false)
            } else {
              setLoading(false)
              toast.error(agency_id ? "Failed to update user" : "Failed to add user");
            }
          });     
      }
    } catch (error) {
      setLoading(false)
    }
  };



  const getRoleListDetails = async (params: any) => {
    let filters = {
      type: 2
    }
    dispatch(getRoleListing.getRoleData(filters)).then((res: any) => {
      if (res && res.status === 200 && res.data) {
        roleList = res.data.filter((e: any) => e.status === 1 && e.type === 2).map((e: any) => {
          return {
            value: e.id,
            label: e.roleName,
            slug: e.slug 
          }
        })
        setRoleList([...roleList]);
      }
      // setLoading(false);
    }).catch((err: Error) => {
      //setLoading(false);
    })
  };

  const getUserList = async () => {
    getAgencySalesUsers({}).then((res: any) => {
      //setLoading(false)

      if (res.status === 200) {
        setSalesUserList(res.data)
      }
    })

  };


 const getAgencyList = async () => {
  try {
    const res: any =  await getRoleListing.getAgencyListData();
    if (res && res.status === 200) {
      setAgencyList(res.data ?? []);
    } else {
      toast.error(agency_id ? "Failed to update user" : "Failed to add user");
    }
  } catch (error) {
    console.error("Error while fetching agency list:", error);
    toast.error("Something went wrong, please try again");
  }
};


  useEffect(() => {
    getUserList();
    getRoleListDetails({});
    getAgencyList();
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    const getMasterConfigData = async () => {
      if (Object.keys(commonState.common).length === 0) {
        const response: any = await dispatch(getMasterConfig());
        setAgencyAgentData(response?.data?.agency_agent_data)
      } else {
        setAgencyAgentData(commonState.common.agency_agent_data)
      }
    }
    getMasterConfigData();
    // eslint-disable-next-line
  }, [dispatch, commonState]);

  useEffect(() => {
    if (agency_id) {
      // Edit case
       setLoading(true);
      getAgencySalesUsers({ id: agency_id }).then((res: any) => {
        if (res.status === 200 && res.data?.length) {
          const userData = res.data[0];
          setFormData((prev: any) => ({
             ...prev,
            name: userData.name || "",
            email: userData.email || "",
            mobile: userData.mobile || "",
            password: "",
            channel_type: userData.channel_type_id || "",
            role_id: userData.role_id || "",
            reporting_role: userData.reporting_role || "",
            reporting_name: userData.reporting_name || "",
             map_sales_agent_officer:
            (userData.map_sales_agent_officer && userData.map_sales_agent_officer.length > 0)
              ? userData.map_sales_agent_officer
              : prev.map_sales_agent_officer,
            role_slug: userData.role_slug,
            status: userData.status
         }));
           setLoading(false);
        }
      });
    } else {
      // Add case: blank form
      setFormData({
        name: "",
        email: "",
        mobile: "",
        password: "",
        channel_type: "",
        role_id: "",
        reporting_role: "",
        reporting_name: "",
        status: 1,
        map_sales_agent_officer:[]
      });
      setLoading(false);  
    }
  }, [agency_id,agencyList]);


  return (
    <React.Fragment>
      <FullPageLoader show={loading} />
      <div className="container-fluid">
        <div className="back-opt">
          <Link to="/agency-sales-user-list" title="Back">
            <i className="ic-arrow_back"></i>
            Back
          </Link>
        </div>
        <div className="dealer-user-mapping-user">
          <div className="top-heading d-flex">
            <h1>{agency_id ? "Edit" : "Add"} - Agency Sales User Management</h1>


          </div>
          <div className="dealer-user-mapping-tab-outer map-dealer-main">
            <div className='map-dealer-outer'>
              <h2>Basic Details</h2>
              <BasicSalesDetails formData={formData} onChange={handleChange} roleList={roleList} salesUserList={salesUserList} agencyAgentData={agencyAgentData} errors={errors} />

              {formData.role_slug === "sales_officer"
                && (<>
                  <div className="p-lg-t">
                    <h2>Sales Users Mapping</h2>
                  </div>
                  <div className='sales-mapped-user-outer'>
                    <SalesMappedUser
                      agencyList={agencyList}
                      mappedUserIds={formData.map_sales_agent_officer}
                      onChange={(mappedUsers: any[]) => {
                        setFormData((prev: any) => ({
                          ...prev,
                          map_sales_agent_officer: mappedUsers.map((u) => u.value),
                        }));
                      }}
                    />
                  </div>
                </>)}

              <div className="btn-submit m-lg-t" >
                <button className="btn-primary" onClick={handleSubmit} >
                  {agency_id ? "Update" : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </React.Fragment>
  )
}

export default MapDealerManagement;